import { CreateAssignmentItemInput } from '@warebee/shared/data-access-api-dto';
import { MappingSchema } from '../mapping';

export const ASSIGNMENT_MAPPING_SCHEMA: MappingSchema<CreateAssignmentItemInput> =
  {
    title: 'Assignment',
    description: 'Assign items to specific locations',
    fields: [
      {
        name: 'consignee',
        type: 'string',
        title: 'Client (Consignee)',
        description:
          'Client (consignee) — Name of your company or your client (if you are a Logistics Services Provider)',
      },
      {
        name: 'sku',
        type: 'string',
        title: 'Item',
        description: 'Item code (SKU)',
      },
      {
        name: 'locationId',
        type: 'string',
        title: 'Location',
        description: 'Location ID/Name, typically in the format AA010101',
      },
      {
        name: 'stockUom',
        type: 'string',
        optional: true,
        title: 'Item UOM',
        description: 'Item UOM stored in a given location',
      },
      {
        name: 'stockUomQuantity',
        type: 'integer',
        optional: true,
        title: 'Item UOM qty',
        description: 'Item quantity in a given location',
      },
    ],
    includeRawData: true,
    primaryKey: ['consignee', 'sku', 'locationId'],
    appendable: true,
  };
